import styled from 'styled-components'

export const FormWrapper = styled.div`
  width: 100%;
  padding: 15px;
`